import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FilterDrawerComponent } from "../../shared/components/filter-drawer/filter-drawer.component";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IOption } from 'app/shared/shared.types';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import dayjs from 'dayjs';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DashboardService } from '../dashboard/pages/services/dashboard/dashboard.service';

@Component({
  selector: 'app-footer-modal',
  standalone: true,
  imports: [CommonModule,FilterDrawerComponent,TranslocoModule,MatButtonToggleModule,MatNativeDateModule,MatFormFieldModule,MatInputModule,ReactiveFormsModule,MatDatepickerModule,MatIconModule,MatButtonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './footer-modal.component.html',
  styleUrl: './footer-modal.component.scss'
})
export class FooterModalComponent {

  isDashboardRoute = false;
  dateRangeControl = new FormControl('T');
  dateRangeForm: FormGroup;
  dateRange: { start?: string; end?: string } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { dateControlOptions: IOption[] },
    private router : Router,
    private fb: FormBuilder,
    private dataDashboardService : DashboardService,
    private dialogRef: MatDialogRef<FooterModalComponent>)
  {
    this.isDashboardRoute = this.router.url.includes('/dashboard');
    this.dateRangeForm = this.fb.group({
      start: [null, Validators.required],
      end: [null, Validators.required],
  });

  this.dateRangeForm.valueChanges.subscribe(() => {
      if (
          this.dateRangeForm.value.start &&
          this.dateRangeForm.value.end
      ) {
          let start = dayjs(this.dateRangeForm.value.start).format(
              'YYYY-MM-DD'
          );
          let end = dayjs(this.dateRangeForm.value.end).format(
              'YYYY-MM-DD'
          );
          this.dateRange = { start, end };
      }
  });
    this.dateRangeControl.valueChanges.subscribe((value ) => {
      this.dateRangeForm.reset();
  });
  }

  reset() {
    this.dateRangeForm.reset();
  }

  save(dateRangeControl : FormControl){
    const dateRange = dateRangeControl.value;
    this.dataDashboardService.setDateRange(dateRange);

    if (this.dateRangeForm.valid) {
      const formData = this.dateRangeForm.value;
      this.dataDashboardService.setFormDateRange(formData);
      this.dialogRef.close();
    } else {
      console.error('Form is invalid:', this.dateRangeForm.errors);
    }

    this.dialogRef.close();
  }

  get dateControlOptions(): IOption[] {
    return this.data.dateControlOptions;
  }

}
